import React from 'react';
import './App.css';
import 'animate.css';
import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { getFirestore, collection, doc, query, where, onSnapshot, Unsubscribe } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBpmNzlQtABl30QFpjQw8iSnKTZHI7nf0I",
  authDomain: "ligatech-acessotech.firebaseapp.com",
  databaseURL: "https://ligatech-acessotech.firebaseio.com",
  projectId: "ligatech-acessotech",
  storageBucket: "ligatech-acessotech.appspot.com",
  messagingSenderId: "359593116769",
  appId: "1:359593116769:web:70c639464330c26d319620",
  measurementId: "G-G6GTTRBFR0",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const EVENT_ID = "58f5db4329614f3ab70c1f034757437f";

interface Sector {
  eventId: string
  sectorId: string
  name: string
}

interface EventDoc {
  name?: string
  startsAt?: any
  [key: string]: any
}

function formatStartsAt(startsAt: any): string {
  if (!startsAt) return '';
  const date: Date | null =
    typeof startsAt?.toDate === 'function' ? startsAt.toDate() :
    startsAt instanceof Date ? startsAt :
    typeof startsAt === 'string' || typeof startsAt === 'number' ? new Date(startsAt) :
    null;
  if (!date || isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function TicketsDashboard({ eventID }: { eventID: string }) {
  const [loadingEntrou, setLoadingEntrou] = React.useState<boolean>(true);
  const [entrou, setEntrou] = React.useState<number>(0);
  const [total, setTotal] = React.useState<number>(0);

  const [sectors, setSectors] = React.useState<Sector[]>([]);
  const [entradasPorSetor, setEntradasPorSetor] = React.useState<Record<string, number>>({});

  React.useEffect(() => {
    const sectorsRef = query(collection(db, "events", eventID, "sectors"));
    const unsub = onSnapshot(sectorsRef, (querySnapshot) => {
      const sectorList: Sector[] = [];
      querySnapshot.forEach((d) => {
        sectorList.push(d.data() as Sector);
      });
      sectorList.sort((a, b) => a.sectorId.localeCompare(b.sectorId, undefined, { numeric: true }));
      setSectors(sectorList);
    });
    return () => unsub();
  }, [eventID]);

  // Total de ingressos carregados no evento.
  React.useEffect(() => {
    const totalQuery = query(collection(db, "events", eventID, "tickets"));
    const unsub = onSnapshot(totalQuery, (querySnapshot) => {
      setTotal(querySnapshot.size);
    });
    return () => unsub();
  }, [eventID]);

  React.useEffect(() => {
    const entrouQuery = query(collection(db, "events", eventID, "tickets"), where("entrou", "==", true));
    const unsub = onSnapshot(entrouQuery, (querySnapshot) => {
      setEntrou(querySnapshot.size);
      setLoadingEntrou(false);
    });
    return () => unsub();
  }, [eventID]);

  React.useEffect(() => {
    if (sectors.length === 0) return;

    const unsubscribes: Unsubscribe[] = sectors.map((sector) => {
      const q = query(
        collection(db, "events", eventID, "tickets"),
        where("setor", "==", sector.sectorId),
        where("entrou", "==", true)
      );
      return onSnapshot(q, (qs) => {
        setEntradasPorSetor((prev) => ({ ...prev, [sector.sectorId]: qs.size }));
      });
    });

    return () => unsubscribes.forEach((unsub) => unsub());
  }, [eventID, sectors]);

  const restantes = Math.max(total - entrou, 0);

  return (
    <>
      <nav className="level">
        <div className="level-item has-text-centered has-background-primary-light p-4">
          <div>
            <p className="heading">acessos</p>
            {loadingEntrou ? (
              <p className="title">carregando...</p>
            ) : (
              <p className="title">{entrou}</p>
            )}
          </div>
        </div>
        <div className="level-item has-text-centered has-background-primary-light p-4">
          <div>
            <p className="heading">ingressos</p>
            <p className="title">{total}</p>
          </div>
        </div>
        <div className="level-item has-text-centered has-background-primary-light p-4">
          <div>
            <p className="heading">a entrar</p>
            <p className="title">{restantes}</p>
          </div>
        </div>
      </nav>

      <nav className="level">
        <div className="level-item has-text-centered has-background-primary-light p-4">
          <div>
            <table className="table is-bordered is-striped is-narrow is-hoverable">
              <thead>
                <tr>
                  <th>Setor</th>
                  <th>Acessos</th>
                </tr>
              </thead>
              <tbody>
                {sectors.map((sector) => {
                  const acesso = entradasPorSetor[sector.sectorId] || 0;
                  return (
                    <tr key={sector.sectorId}>
                      <td>{sector.name}</td>
                      <td key={`key-${sector.sectorId}-${acesso}`} className="animate__animated animate__flash">{acesso}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </nav>
    </>
  );
}

function App() {
  const [authenticated, setAuthenticated] = React.useState<boolean>(false);
  const [eventDoc, setEventDoc] = React.useState<EventDoc | null>(null);

  React.useEffect(() => {
    signInWithEmailAndPassword(auth, 'dashboard@ligatech.com.br', 'temppassword')
      .then(() => {
        console.log("authenticated.");
        setAuthenticated(true);
      })
      .catch((error) => {
        console.error("deu ruim:", error);
      });
  }, []);

  React.useEffect(() => {
    if (!authenticated) return;
    const eventRef = doc(db, "events", EVENT_ID);
    const unsub = onSnapshot(eventRef, (snapshot) => {
      const data = snapshot.exists() ? (snapshot.data() as EventDoc) : null;
      setEventDoc(data);
    });
    return () => unsub();
  }, [authenticated]);

  const title = 'Baile de Aniversário 79 Anos';
  const subtitle = 'Show Péricles — Salão Social';
  const datetime = formatStartsAt(eventDoc?.startsAt);

  return (
    <div className="App">
      <div className="container">
        <div className="section">
          <nav className="level">
            <div className="level-item has-text-centered has-background-primary-light p-4">
              <div>
                <h1 className='title mb-4'>{title}</h1>
                <h2 className='subtitle mb-2'>{subtitle}</h2>
                {datetime && <p className='is-size-6'>{datetime}</p>}
              </div>
            </div>
          </nav>

          {authenticated && (
            <TicketsDashboard eventID={EVENT_ID} />
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
